import "./MOQBanner.css"
import { Link } from "react-router-dom"
function MOQBanner(){

return(

<Link to="/b2b" className="moqLink">

<div className="moqBanner">

<h2>Minimum Order ₹5000</h2>

<p>Bulk Discounts Available</p>

</div>

</Link>
)

}

export default MOQBanner